var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "page-content account acc_verification",
      class: {
        "padding-0": !_vm.accountSummaryFlow,
        "padding-30": _vm.accountSummaryFlow
      }
    },
    [
      _c("VerTitles", {
        attrs: {
          currentStep: _vm.currentStep,
          maxStep: _vm.maxStep,
          currStepTitle: _vm.verifyDetail,
          isMapPage: true
        },
        on: { closePage: _vm.closeVerPage }
      }),
      _vm._v(" "),
      !_vm.isChageDetails
        ? _c(
            "div",
            [
              _c(_vm.currentComponent, {
                tag: "component",
                attrs: {
                  page: _vm.currentPage,
                  state: _vm.currentPageState,
                  mapUpdating: _vm.mapIsUpdating
                },
                on: {
                  refreshafteraction: _vm.updateCom,
                  changeDetailEmail: _vm.changeDetails,
                  changeDetailPhone: _vm.changeDetails
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm.isChageDetails
            ? _c("ChangeDetail", {
                attrs: { page: _vm.currentPage },
                on: {
                  goBackEmail: _vm.changeDetails,
                  goBackPhone: _vm.changeDetails,
                  updateCom: _vm.updateCom
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2784f9cd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2784f9cd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/Verification/Verification.vue
// module id = null
// module chunks = 